import React from 'react';

export const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.62335 7.50016C8.16311 7.50016 7.79002 7.87326 7.79002 8.3335V16.6668C7.79002 17.1271 8.16311 17.5002 8.62335 17.5002H16.9567C17.4169 17.5002 17.79 17.1271 17.79 16.6668V8.3335C17.79 7.87326 17.4169 7.50016 16.9567 7.50016H8.62335ZM6.12335 8.3335C6.12335 6.95278 7.24264 5.8335 8.62335 5.8335H16.9567C18.3374 5.8335 19.4567 6.95278 19.4567 8.3335V16.6668C19.4567 18.0475 18.3374 19.1668 16.9567 19.1668H8.62335C7.24264 19.1668 6.12335 18.0475 6.12335 16.6668V8.3335Z"
      fill="var(--color-text-primary-alt)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.62335 2.50016C3.16692 2.50016 2.79002 2.87707 2.79002 3.3335V11.6668C2.79002 12.1233 3.16692 12.5002 3.62335 12.5002C4.08359 12.5002 4.45669 12.8733 4.45669 13.3335C4.45669 13.7937 4.08359 14.1668 3.62335 14.1668C2.24645 14.1668 1.12335 13.0437 1.12335 11.6668V3.3335C1.12335 1.95659 2.24645 0.833496 3.62335 0.833496H11.9567C13.3336 0.833496 14.4567 1.95659 14.4567 3.3335C14.4567 3.79373 14.0836 4.16683 13.6234 4.16683C13.1631 4.16683 12.79 3.79373 12.79 3.3335C12.79 2.87707 12.4131 2.50016 11.9567 2.50016H3.62335Z"
      fill="var(--color-text-primary-alt)"
    />
  </svg>
);
